import React, { Suspense, lazy } from 'react';

import { useLocation } from 'react-router-dom';

import { Container, Typography } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import { decodeShellView } from '~/pages/AskRichardUnified/shellUrlState';
import { SurfacePlate } from '~/pages/LeLens/surface';

import useCanAccessLeLens from '~/hooks/useCanAccessLeLens';

const SharedLensPage = lazy(() => import('./LeLensPage'));
const LENS_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

type LensAccessGateProps = { children: React.ReactNode };

export default function LensAccessGate({ children }: LensAccessGateProps) {
  const canAccess = useCanAccessLeLens();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const state = decodeShellView(params);
  const legacyId = location.pathname.match(/^\/le-lens\/([^/]+)\/?$/)?.[1];
  const lensId =
    legacyId ?? (/^\/ask-richard-unified\/?$/.test(location.pathname) && state.view === 'lens' ? state.lensId : null);

  if (!canAccess && lensId && LENS_ID.test(lensId)) {
    return (
      <Suspense fallback={null}>
        <main>
          <SharedLensPage lensId={lensId} selectedCardId={params.get('card')?.trim() || null} />
        </main>
      </Suspense>
    );
  }

  if (!canAccess) {
    return (
      <Container>
        <PageHeader title="askRichard" />
        <SurfacePlate padding="plate">
          <Typography sx={{ fontWeight: 700 }} variant="subtitle1">
            askRichard is in a closed pilot.
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 1 }} variant="body2">
            Today it&apos;s open to reporting admins and a small pilot list. To be added, email{' '}
            <a href="mailto:data@luxuryescapes.com">data@luxuryescapes.com</a> and say what you&apos;d use it for.
          </Typography>
        </SurfacePlate>
      </Container>
    );
  }

  return <>{children}</>;
}
